<template lang="html">
  <div class="pa-2">
    <h1>SEQUENCES</h1>
    <div
      v-for="sequence in getCommunitySuggestedSequences"
      :key="`${sequence.template_type}sequence${sequence.id}`"
      class="mb-5 pa-3"
    >
      <StandardFlexBox>
        <h2>{{ sequence.name }} <small>by {{ sequence.owner.first_name }} {{ sequence.owner.last_name }} ({{ sequence.owner.email }})</small></h2>
      </StandardFlexBox>
      <StandardFlexBox>
        <TrainHead :zoom="1" style="flex-shrink: 0"/>
        <Waggon
          v-for="waggon in sequence.waggons"
          :key="`${sequence.template_type}swaggons${waggon.id}`"
          :zoom="1"
          :workpackage_count="waggon.work_packages.length"
          style="flex-shrink: 0"
          >
          <template #content>
            <WorkPackage
              v-for="workpackage in waggon.work_packages"
              :key="`${sequence.template_type}swaggons${workpackage.id}`"
              :workpackage_count="waggon.work_packages.length"
              :workpackage="workpackage"
              :zoom="1"
              />
            </template>
        </Waggon>
        <TrainTail :zoom="1" style="flex-shrink: 0"/>
      </StandardFlexBox>
      <StandardFlexBox class="mt-2 pl-0 pa-2">
        <CommunityDeclineDialog :el="sequence" @declineCommunityClick="declineSequenceCommunityState($event)" />
        <CommunityAcceptDialog :el="sequence" @acceptCommunityClick="acceptAndCreateCommunitySequence($event)"/>
      </StandardFlexBox>
    </div>
    <h1>WAGONS</h1>
    <div
      v-for="waggon in getCommunitySuggestedWaggons"
      :key="`${waggon.template_type}waggon${waggon.id}`"
      class="mb-5 pa-3"
    >
      <StandardFlexBox>
        <h2>{{ waggon.token }} <small>by {{ waggon.owner.first_name }} {{ waggon.owner.last_name }} ({{ waggon.owner.email }})</small></h2>
      </StandardFlexBox>

      <StandardFlexBox>
        <Waggon
          :workpackage_count="waggon.work_packages.length"
          :zoom="3"
          >
          <template #content>
            <div class="token-view" style="font-size: xx-large;">
              {{waggon.token?waggon.token:'No Token'}}
            </div>
            <WorkPackage
              v-for="(workpackage) in waggon.work_packages"
              :key="`wagworkpackage${workpackage.id}`"
              :workpackage_count="waggon.work_packages.length"
              :workpackage="workpackage"
              :zoom="3"
              />
          </template>
        </Waggon>
      </StandardFlexBox>
      <StandardFlexBox class="mt-2 pl-0 pa-2">
        <CommunityDeclineDialog :el="waggon" @declineCommunityClick="declineWaggonCommunityState($event)" />
        <CommunityAcceptDialog :el="waggon" @acceptCommunityClick="acceptAndCreateCommunityWaggon($event)"/>
      </StandardFlexBox>
    </div>
    <h1>WORKPACKAGES</h1>
    <div
      v-for="workpackage in getCommunitySuggestedWorkPackages"
      :key="`${workpackage.template_type}waggon${workpackage.id}`"
      class="mb-5 pa-3"
    >
      <StandardFlexBox>
        <h2>{{ workpackage.name }} <small>by {{ workpackage.owner.first_name }} {{ workpackage.owner.last_name }}({{ workpackage.owner.email }})</small></h2>
      </StandardFlexBox>

      <StandardFlexBox>
        <WorkPackage
          :workpackage_count="1"
          :workpackage="workpackage"
          :zoom="3"
          />
      </StandardFlexBox>
      <StandardFlexBox class="mt-2 pl-0 pa-2">
        <CommunityDeclineDialog :el="workpackage" @declineCommunityClick="declineWorkPackageCommunityState($event)" />
        <CommunityAcceptDialog :el="workpackage" @acceptCommunityClick="acceptAndCreateCommunityWorkPackage($event)"/>
      </StandardFlexBox>

    </div>
    <h1>MATERIALS</h1>
    <div
      v-for="material in getCommunitySuggestedMaterials"
      :key="`${material.template_type}waggon${material.id}`"
      class="mb-5 pa-3"
    >
      <StandardFlexBox>
        <h2>{{ material.name }} <small>by {{ material.owner.first_name }} {{ material.owner.last_name }} ({{ material.owner.email }})</small></h2>
      </StandardFlexBox>

      <StandardFlexBox>
        <v-card
          color="secondary"
          class="ma-1 cursor-pointer font-weight-light"
          width="192px"
          height="128px"
        >
        <v-card-title>{{material.name}}</v-card-title>
        <v-card-text>{{material.description}}</v-card-text>
      </v-card>
      </StandardFlexBox>
      <StandardFlexBox class="mt-2 pl-0 pa-2">
        <CommunityDeclineDialog :el="material" @declineCommunityClick="declineMaterialCommunityState($event)" />
        <CommunityAcceptDialog :el="material" @acceptCommunityClick="acceptAndCreateCommunityMaterial($event)"/>
      </StandardFlexBox>
    </div>
  </div>
</template>

<script>

import CommunityDeclineDialog from '@/components/Community/CommunityDeclineDialog.component.vue';
import CommunityAcceptDialog from '@/components/Community/CommunityAcceptDialog.component.vue';

import TrainHead from '@/components/ProjectTaktPlan/TrainHead.component.vue';
import Waggon from '@/components/ProjectTaktPlan/Waggon.component.vue';
import WorkPackage from '@/components/ProjectTaktPlan/Workpackage.component.vue';
import StandardFlexBox from '@/components/StandardComponents/StandardFlexBox.component.vue';
import TrainTail from '@/components/ProjectTaktPlan/TrainTail.component.vue';

import store from '@/store/index';
import {
  mapGetters,
  mapActions
 } from 'vuex';
export default {
  name: 'Community',
  components: {
    CommunityDeclineDialog,
    CommunityAcceptDialog,
    TrainHead,
    Waggon,
    WorkPackage,
    StandardFlexBox,
    TrainTail
  },
  mixins: [],
  beforeRouteEnter (to, from, next) {
    store.dispatch('Community/requestCommunitySuggested').then(res => next(res));
  },
  computed: {
    ...mapGetters('Community', [
      'getCommunitySuggestedSequences',
      'getCommunitySuggestedWorkPackages',
      'getCommunitySuggestedWaggons',
      'getCommunitySuggestedMaterials',
      'isLoading'
    ]),
  },
  data: function () {
    return {
      waggon_large_dialog: false,
      work_packages_large: [],
      work_packages_large_index: 0
    }
  },
  methods: {
    ...mapActions('Community', [
      'declineSequenceCommunityState',
      'declineWorkPackageCommunityState',
      'declineWaggonCommunityState',
      'acceptAndCreateCommunitySequence',
      'acceptAndCreateCommunityWorkPackage',
      'acceptAndCreateCommunityWaggon',
      'acceptAndCreateCommunityMaterial',
    ])
  }
}
</script>

<style lang="css" scoped>

.token-view {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: rgb(106 106 106 / 80%);
  z-index: 2;
  cursor: pointer;
  font-weight: bold;
}
</style>
